import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "panel", "backdrop" ]

  connect() {
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  open() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("hidden")
    }
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("hidden")
    }

    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundCloseOnEscape)
  }

  close() {
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("hidden")
    }
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("hidden")
    }

    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
